(function() { module.exports = window["wp"]["notices"]; }());